"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var QuickOptionEntry_1 = require("./QuickOptionEntry");
var QuickOptionSearchEntry_1 = require("./QuickOptionSearchEntry");
var mountAndShowFullOptions_1 = require("../../utils/mountAndShowFullOptions");
var owa_options_store_1 = require("owa-options-store");
var filterOptions_1 = require("../../utils/filterOptions");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var SearchBox_1 = require("office-ui-fabric-react/lib/SearchBox");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var SettingPanelFirstRunCallout_1 = require("./SettingPanelFirstRunCallout");
var ReactDOM = require("react-dom");
var owa_lightning_1 = require("owa-lightning");
var styles = require('./QuickOptions.scss');
var classNames = require('classnames/bind').bind(styles);
var QuickOptions = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptions, _super);
    function QuickOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        _this.goToFullOptions = function () {
            mountAndShowFullOptions_1.default();
            _this.onDismiss();
        };
        return _this;
    }
    QuickOptions.prototype.render = function () {
        var _this = this;
        var store = owa_options_store_1.getStore();
        var displayedOptions = filterOptions_1.default(store.searchTerm) || owa_options_store_1.getQuickOptions();
        var isSearch = !!store.searchTerm;
        var target;
        return (React.createElement("div", { className: styles.container },
            React.createElement(SearchBox_1.SearchBox, { labelText: owa_options_strings_1.default.optionsFlex_searchPlaceholder, value: store.searchTerm, onChange: owa_options_store_1.setSearchTerm }),
            React.createElement("div", { className: styles.quickSettingsPanel },
                displayedOptions.map(function (option, index) {
                    return isSearch ? (React.createElement(QuickOptionSearchEntry_1.default, { onDismiss: _this.props.onDismiss, option: option, key: option.key })) : (React.createElement(QuickOptionEntry_1.default, { ref: function (ref) {
                            if (index == 0) {
                                target = ReactDOM.findDOMNode(ref);
                            }
                        }, onDismiss: _this.props.onDismiss, option: option, key: option.key }));
                }),
                React.createElement(SettingPanelFirstRunCallout_1.SettingPanelFirstRunCallout, { lid: owa_lightning_1.LightningId.SettingPanelFirstRunCallout, when: function (lightup) { return lightup(); }, series: [
                        owa_lightning_1.LightningId.AnimatedConsumerRefreshFRE2,
                        owa_lightning_1.LightningId.SettingPanelFirstRunCallout,
                        owa_lightning_1.LightningId.SettingIconFirstRunCallout,
                    ], target: function () { return target; } })),
            React.createElement(Button_1.CommandButton, { className: styles.viewFullSettings, onClick: this.goToFullOptions },
                React.createElement("span", null, owa_options_strings_1.default.optionsFlex_goToFullOptions),
                React.createElement(Icon_1.Icon, { iconName: "ChevronRight" /* ChevronRight */, className: classNames(styles.icon, 'flipForRtl') }))));
    };
    QuickOptions.prototype.componentWillUnmount = function () {
        this.onDismiss();
    };
    QuickOptions = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptions);
    return QuickOptions;
}(React.Component));
exports.default = QuickOptions;
//# sourceMappingURL=QuickOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/quick/QuickOptions.js
// module id = 4911
// module chunks = 2